import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ThemeProvider } from '@carvana/theme';
import LoadingSpinner from '@carvana/loading-spinner';
import useLoadTimeTracking from '../hooks/useLoadTimeTracking';

type StyleProps = {
  small: boolean;
  show?: boolean;
};

const Container = styled.div<StyleProps>`
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
  text-align: center;
  padding-top: ${props => !props.small && '2rem'};
  transition: ${props => props.show && 'opacity 1.5s ease 0s'};
  opacity: ${props => (props.show ? 1 : 0)};
`;

const Title = styled.p<StyleProps>`
  font-size: ${props => (props.small ? 17 : 27)}px;
  font-weight: 700;
`;

const SubText = styled.p<StyleProps>`
  font-size: ${props => (props.small ? '14' : '20')}px;
  font-weight: 700;
  margin-bottom: 30px;
`;

const defaultProps = {
  title: 'Please Wait',
  hideTitle: false,
  subtext: null as string | null,
  timeout: 750,
  small: false
};

const Loading: React.FC<Partial<typeof defaultProps>> = (
  props = defaultProps
) => {
  useLoadTimeTracking();

  const { title, subtext, hideTitle, small, timeout } = props;

  const [show, setShow] = useState(false);

  const displayLoading = () => {
    setShow(true);
  };

  useEffect(() => {
    const timer = setTimeout(displayLoading, timeout);

    return () => {
      setShow(false);
      clearTimeout(timer);
    };
  }, []);

  return (
    <Container show={show} small={small}>
      <Fragment>
        {show && (
          <div>
            {!hideTitle && <Title small={small}>{title}</Title>}
            <ThemeProvider>
              <LoadingSpinner isLarge={!small} alt="loading" />
            </ThemeProvider>
            {subtext && <SubText small={small}>{subtext}</SubText>}
          </div>
        )}
      </Fragment>
    </Container>
  );
};

export default Loading;
